import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Header } from 'semantic-ui-react';

export default class BusinessUnitDropdownWithCategories extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.array]).isRequired,
    placeholder: PropTypes.string,
    style: PropTypes.shape({}),
    companyBranches: PropTypes.arrayOf(PropTypes.shape({})),
    fullCompanyBranches: PropTypes.arrayOf(PropTypes.shape({})),
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    const value = Array.isArray(props.value) ? props.value : [];
    const placeholder = props.placeholder;
    const companyBranches = props.companyBranches || [];
    const fullCompanyBranches = props.fullCompanyBranches || [];
    return {
      value,
      placeholder,
      branches: companyBranches,
      fullBranches: fullCompanyBranches,
    };
  }
  constructor(props) {
    super(props);
    const state = BusinessUnitDropdownWithCategories.getPropsToState(props);
    this.state = {
      ...state,
      isOpen: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = BusinessUnitDropdownWithCategories.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }

  getInternalBranchIds() {
    const { fullBranches } = this.state;
    return fullBranches.filter(branch => !branch.isExternal).map(branch => branch.id);
  }

  getExternalBranchIds() {
    const { fullBranches } = this.state;
    return fullBranches.filter(branch => branch.isExternal).map(branch => branch.id);
  }

  getAllBranchIds() {
    const { fullBranches } = this.state;
    return fullBranches.map(branch => branch.id);
  }

  handleOnChange = (e, { value }) => {
    let newValue = [...value];

    // Handle special select all cases
    if (value.includes('select-all')) {
      // Select all branches
      newValue = this.getAllBranchIds();
    } else if (value.includes('select-all-internal')) {
      // Remove the special value and add all internal branches
      newValue = newValue.filter(v => v !== 'select-all-internal');
      const internalIds = this.getInternalBranchIds();
      // Add internal IDs that aren't already selected
      internalIds.forEach((id) => {
        if (!newValue.includes(id)) {
          newValue.push(id);
        }
      });
    } else if (value.includes('select-all-agency')) {
      // Remove the special value and add all external branches
      newValue = newValue.filter(v => v !== 'select-all-agency');
      const externalIds = this.getExternalBranchIds();
      // Add external IDs that aren't already selected
      externalIds.forEach((id) => {
        if (!newValue.includes(id)) {
          newValue.push(id);
        }
      });
    } else if (value.includes('deselect-all')) {
      newValue = [];
    } else if (value.includes('deselect-all-internal')) {
      newValue = newValue.filter(v => v !== 'deselect-all-internal');
      const internalIds = this.getInternalBranchIds();
      newValue = newValue.filter(id => !internalIds.includes(id));
    } else if (value.includes('deselect-all-agency')) {
      newValue = newValue.filter(v => v !== 'deselect-all-agency');
      const externalIds = this.getExternalBranchIds();
      newValue = newValue.filter(id => !externalIds.includes(id));
    }

    // Filter out special values and divider
    newValue = newValue.filter(v =>
      v !== 'select-all' &&
      v !== 'select-all-internal' &&
      v !== 'select-all-agency' &&
      v !== 'deselect-all' &&
      v !== 'deselect-all-internal' &&
      v !== 'deselect-all-agency' &&
      v !== 'divider',
    );

    if (this.props.onChange) {
      this.props.onChange(newValue);
    }
  }

  handleOnOpen = () => {
    this.setState({ isOpen: true });
  }

  handleOnClose = () => {
    this.setState({ isOpen: false });
  }

  renderLabel = (label) => {
    const { isOpen, value, branches } = this.state;
    const safeValue = Array.isArray(value) ? value : [];
    if (isOpen || safeValue.length <= 1) {
      return {
        ...label,
        content: label.text,
      };
    }
    const selectedBranches = branches.filter(branch => safeValue.includes(branch.value));
    const firstValue = selectedBranches.length > 0 ? selectedBranches[0].value : null;

    if (label.value !== firstValue) {
      return null;
    }
    return {
      ...label,
      content: <span style={{ fontSize: '12px' }}>{label.text}</span>,
    };
  }

  getRemainingText = () => {
    const { isOpen, value } = this.state;
    const safeValue = Array.isArray(value) ? value : [];

    if (!isOpen && safeValue.length > 1) {
      const remaining = safeValue.length - 1;
      return (
        <span
          style={{
            fontSize: '12px',
            color: '#999',
            marginLeft: '4px',
            fontWeight: 'normal',
          }}
        >
          +{remaining}
        </span>
      );
    }
    return null;
  }

  render() {
    const {
      branches,
      value,
      placeholder,
      fullBranches,
    } = this.state;
    const { style } = this.props;
    const safeValue = Array.isArray(value) ? value : [];
    const dynamicOptions = [];
    const hasInternalBranches = fullBranches && fullBranches.some(branch => !branch.isExternal);
    const hasExternalBranches = fullBranches && fullBranches.some(branch => branch.isExternal);
    const branchById = fullBranches ? fullBranches.reduce((acc, branch) => ({ ...acc, [branch.id]: branch }), {}) : {};
    const selectedInternalIds = safeValue.filter((id) => {
      const branch = branchById[id];
      return branch && !branch.isExternal;
    });
    const selectedExternalIds = safeValue.filter((id) => {
      const branch = branchById[id];
      return branch && branch.isExternal;
    });
    const allInternalIds = this.getInternalBranchIds();
    const allExternalIds = this.getExternalBranchIds();
    const allIds = this.getAllBranchIds();
    const hasUnselectItems = safeValue.length < allIds.length;
    const hasUnselectInternalItems = hasInternalBranches && selectedInternalIds.length < allInternalIds.length;
    const hasUnselectExternalItems = hasExternalBranches && selectedExternalIds.length < allExternalIds.length;
    if (hasUnselectItems) {
      dynamicOptions.push({
        key: 'select-all',
        text: 'Select All',
        value: 'select-all',
        content: <Header as="h5" style={{ margin: 0 }} content="Select All" />,
      });
    }
    if (hasUnselectInternalItems) {
      dynamicOptions.push({
        key: 'select-all-internal',
        text: 'Select All Internal',
        value: 'select-all-internal',
        content: <Header as="h5" style={{ margin: 0 }} content="Select All Internal" />,
      });
    }
    if (hasUnselectExternalItems) {
      dynamicOptions.push({
        key: 'select-all-agency',
        text: 'Select All Agency',
        value: 'select-all-agency',
        content: <Header as="h5" style={{ margin: 0 }} content="Select All Agency" />,
      });
    }
    const hasSelectedItems = safeValue.length > 0;
    const hasSelectedInternalItems = selectedInternalIds.length > 0;
    const hasSelectedExternalItems = selectedExternalIds.length > 0;
    if (hasSelectedItems) {
      dynamicOptions.push({
        key: 'deselect-all',
        text: 'Deselect All',
        value: 'deselect-all',
        content: <Header as="h5" style={{ margin: 0 }} content="Deselect All" />,
      });
    }
    if (hasSelectedInternalItems) {
      dynamicOptions.push({
        key: 'deselect-all-internal',
        text: 'Deselect All Internal',
        value: 'deselect-all-internal',
        content: <Header as="h5" style={{ margin: 0 }} content="Deselect All Internal" />,
      });
    }
    if (hasSelectedExternalItems) {
      dynamicOptions.push({
        key: 'deselect-all-agency',
        text: 'Deselect All Agency',
        value: 'deselect-all-agency',
        content: <Header as="h5" style={{ margin: 0 }} content="Deselect All Agency" />,
      });
    }
    const allOptions = [...dynamicOptions, ...branches];
    const remaining = this.getRemainingText();
    return (
      <div className="business-unit-dropdown">
        <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
          Visibility by Business Unit
        </div>
        <div style={{ position: 'relative' }}>
          <Dropdown
            fluid
            multiple
            onChange={this.handleOnChange}
            onOpen={this.handleOnOpen}
            onClose={this.handleOnClose}
            options={allOptions}
            search
            selection
            placeholder={placeholder || 'Select Business Unit Access'}
            value={safeValue}
            style={style}
            renderLabel={this.renderLabel}
          />
          {remaining && (
            <div
              style={{
                position: 'absolute',
                right: '30px',
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
                zIndex: 1,
              }}
            >
              {remaining}
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sortable/SortablePackagePricing/BusinessUnitDropdownWithCategories.jsx